import { apis } from '@/config';
import { api } from '@/api/api';
class MailProductImplApi {
    constructor() {
        this.name = apis.mailProductImplApi;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
    }
    init() {
        return this.name;
    }
    async handlePromise(promise) {
        try {
            const res = await promise;
            const { data } = res.data;
            if (data) {
                return data;
            }
            else {
                return { totalCount: 0 };
            }
        }
        catch (e) {
            console.log('e====>', e);
            return {
                error: true,
            };
        }
    }
    async getWaimaoProductList(req) {
        if (!process.env.BUILD_ISEDM) {
            return Promise.resolve({});
        }
        const url = this.systemApi.getUrl('getWaimaoProductList');
        const res = await this.handlePromise(this.http.get(url, req));
        return res;
    }
}
const mailProductApiImpl = new MailProductImplApi();
api.registerLogicalApi(mailProductApiImpl);
export default mailProductApiImpl;
